import CommonStore from '../common_store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import api from '../../../api'
import {message} from 'antd'
import dayjs from "dayjs";

class LanguageStore {
  commonStore?: CommonStore
  constructor(baseStore?: CommonStore) {
    this.commonStore = baseStore
    makeObservable(this)
  }
  @observable searchForm: any = {}
  @observable tableData: any = {}
  //表格加载状态
  @observable tableLoad: boolean = true
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page
        this.pageData.size = size
        this.pageData = { ...this.pageData }
      })
      this.getLanguagePage()
    },
  }
  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj
    })
  }
  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1
    })
  }

  //分页查询
  @action
  getLanguagePage() {
    if (this.searchForm.applicationTime) {
      this.searchForm.endTime = this.searchForm.applicationTime[1].format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.searchForm.startTime = this.searchForm.applicationTime[0].format(
        'YYYY-MM-DD HH:mm:ss'
      )
    }
    runInAction(() => {
      this.tableData = {}
      this.tableLoad = true
    })
    const data = { ...this.searchForm }
    data.size = this.pageData.size
    data.page = this.pageData.page
    if (!data.startTime) {
      let now = dayjs().add(1,'day').hour(0).minute(0).second(0);
      data.startTime = now.subtract(7, 'day').format(
          'YYYY-MM-DD HH:mm:ss')
      data.endTime = now.format(
          'YYYY-MM-DD HH:mm:ss')
    }
    api.languageApi
      .getLanguagePage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data
            this.tableData = { ...this.tableData }
            this.tableLoad = false
          })
        }
        this.geAllList()
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false
        })
      })
  }
  //导出
  @action
  exportError() {
    if (!this.searchForm.startTime) {
      let now = dayjs().add(1,'day').hour(0).minute(0).second(0);
      this.searchForm.startTime = now.subtract(7, 'day').format(
          'YYYY-MM-DD HH:mm:ss')
      this.searchForm.endTime = now.format(
          'YYYY-MM-DD HH:mm:ss')
    }
    api.languageApi
      .languageExport(this.searchForm)
      .then(async (res: any) => {
        message.success('导出成功')
      })
      .catch((err: any) => {
        const blob = new Blob([err], {
          type: 'application/vnd.ms-excel',
        })
        if ('download' in document.createElement('a')) {
          // 生成<a></a >DOM元素
          const link = document.createElement('a')
          link.download = '通话明细.xlsx'
          link.style.display = 'none'
          // a标签的href属性指定下载链接
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          // 必须点击否则不会下载
          link.click()
          URL.revokeObjectURL(link.href) // 释放URL 对象
          document.body.removeChild(link)
        }
      })
  }

  @observable isOpenDetail: boolean = false //控制查看详情弹框
  @observable detailData: any = {} //查看详情数据
  @observable modalLoading: boolean = false
  //控制查看详情弹框
  closeDetailModal(record?: any) {
    runInAction(() => {
      this.isOpenDetail = false
    })
  }
  //控制查看详情弹框
  async openDetailModal(record: any) {
    await this.getFileUrl(record)
      .then(() => {
        runInAction(() => {
          this.detailData = record;
          this.isOpenDetail = true;
        });
      })
      .catch((e: any) => {});
  }
  @observable recordData: any = {} //录音详情数据
  //获取录音文件地址,
  @action
  async getFileUrl(data: any) {
    await api.languageApi
        .languageDetail(data)
        .then((res: any) => {
          runInAction(() => {
            this.recordData = res
          })
        })
        .catch((err: any) => {})
  }
  @observable getAllbotList: any = [];  //话术下拉框

  @action
  async geAllList() {
    api.languageApi
      .botAllList()
      .then((res: any) => {
        runInAction(() => {
          this.getAllbotList = res.data;
        });
      })
      .catch((e: any) => {});
  }
}

export default LanguageStore
